export default __webpack_public_path__ + "static/DSC_0056-a33e8ea317a4f1ffdf3cf2eecb3418db.jpg";